import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  "& .mantine-usvkjp": {
    paddingLeft: "0 !important",
    paddingRight: "0 !important",
  },
  wrapperContainer: {
    marginBlock: 50,
    width: "100%",
  },
  pkgGrid: {
    "@media (max-width :80em)": {
      display: "flex !important",
      flexDirection: "column !important",
    },
  },
  accHdng: {
    fontFamily: "Inter",
    fontSize: 24,
    fontWeight: 700,
    color: "#000",
    marginBottom: 15,
  },
  monthlyAndYearlyTab: {
    "& .mantine-Tabs-tabsList": {
      marginBottom: "40px",
      width: "fit-content",
      backgroundColor: "#171717",
      marginInline: "auto",
      borderRadius: "28px",
      padding: "4px",
      "& .mantine-Tabs-tab": {
        color: "#FFFFFF",
        fontFamily: "Inter",
        fontSize: "20px",
        fontWeight: "400",
        padding: "14px 30px",
        borderRadius: "28px",
        "&:hover": {
          backgroundColor: "#171717",
          color: "#FFFFFF",
          opacity: 0.9,
        },
        "&[data-active]": {
          backgroundColor: "#FFAF4A",
          "&:hover": {
            backgroundColor: "#FFAF4A",
            color: "#FFFFFF",
            opacity: "unset",
          },
        },
      },
    },
  },
  contentWrapper: {
    borderRadius: 12,
    backgroundColor: "#FFF",
    padding: 35,
    display: "flex",
    flexDirection: "column",
    gap: 34,
  },
}));

export default useStyles;
